import React from 'react';
import { BarChart3 } from 'lucide-react';

export const NoData = ({ title = 'No data yet', hint, icon: I = BarChart3, className = '' }) => (
  <div className={`h-full w-full flex flex-col items-center justify-center text-center py-8 ${className}`} data-testid="no-data-state">
    <div className="w-11 h-11 rounded-2xl bg-white/[0.04] border border-white/10 flex items-center justify-center mb-3">
      <I className="w-5 h-5 text-white/25" />
    </div>
    <div className="text-sm font-medium text-white/60">{title}</div>
    {hint && <div className="text-xs text-white/35 mt-1 max-w-xs leading-relaxed">{hint}</div>}
  </div>
);

export default NoData;
